import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "trigger"];

  toggle() {
    const isHidden = this.menuTarget.classList.toggle("hidden");
    if (!isHidden) this.position();
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
    }
  }

  position() {
    const rect = this.triggerTarget.getBoundingClientRect();
    const menu = this.menuTarget;

    menu.style.left = `${rect.left}px`;
    menu.style.width = `${rect.width}px`;
    menu.style.bottom = `${window.innerHeight - rect.top + 4}px`;
  }
}
